import gql from 'graphql-tag';

export const QUERY_PRODUCTS = gql`query ($currentCategoryId: Int, $offset: Int, $field: ProductsOrderByEnum = DATE, $order: OrderEnum = DESC, $size: Int, $attribute: String, $attributeTerm: String, $hireSale: String, $currentSectorId: [Int]) {
  products(where: {offsetPagination: {offset: $offset, size: $size}, categoryId: $currentCategoryId, visibility: VISIBLE, orderby: {field: $field, order: $order}, attributeTerm: $attributeTerm, attribute: $attribute, hireSale: $hireSale, taxonomyFilter: {or: {taxonomy: PRODUCTSECTOR, ids: $currentSectorId, operator: AND}}}, first: $size) {
    nodes {
      databaseId
      slug
      name
      reviewCount
      type
      image {
        sourceUrl(size: THUMBNAIL)
      }
      link
      ... on SimpleProduct {
        price
      }
      ... on VariableProduct {
        id
        name 
        price
      }
      reviews {
        averageRating
      }
      acfProducts {
        productType
        hireId
        hirePriceWeek
      }
    }
    pageInfo {
      offsetPagination {
        total
        hasMore
        hasPrevious
      }
    }
  }
}
`;
export default QUERY_PRODUCTS;